import { Target } from 'lucide-react'

import { RubricInlineCriteriaList } from '@/components/admin/evaluation-rubrics/rubric-inline-criteria-list'
import { rubricSectionHighlight } from '@/components/admin/evaluation-rubrics/rubric-section-ids'
import { EntityManageSection } from '@/components/ui/entity-manage-section'
import { type RubricCriterion } from '@/hooks/use-evaluation-rubrics-admin'

type RubricFocusAreasSectionProps = {
  criteria: RubricCriterion[]
  highlighted?: boolean
  onChange: (criteria: RubricCriterion[]) => void
  onEditLevelsSkills: (criterionKey?: string) => void
}

export function RubricFocusAreasSection({
  criteria,
  highlighted,
  onChange,
  onEditLevelsSkills,
}: RubricFocusAreasSectionProps) {
  return (
    <div id={rubricSectionHighlight('focus')}>
      <EntityManageSection
        title="Focus areas"
        subtitle="Competencies the AI should look for, often with performance levels"
        leadingIcon={Target}
        onEdit={() => onEditLevelsSkills()}
        editAriaLabel="Edit levels and skills"
        editTitle="Levels & skills"
        highlighted={highlighted}
        agentHighlight={rubricSectionHighlight('focus')}
      >
        <RubricInlineCriteriaList
          criteria={criteria}
          kind="competency"
          onChange={onChange}
          onEditLevelsSkills={(key) => onEditLevelsSkills(key)}
        />
      </EntityManageSection>
    </div>
  )
}
